(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  /* ============ EPMS VAT TOGGLE JS ============ */

  (function () {
    const VAT_RATE = 0.20;

    /*
     * New key so the old saved INC VAT setting
     * cannot override the corrected EX VAT default.
     */
    const STORAGE_KEY = 'epms_vat_mode_v2';

    const PRICE_SELECTOR = '.price-item';
    const CURRENCY_SYMBOL = '£';


    function parsePrice(text) {
      const cleanText = text.replace(/,/g, '');
      const match = cleanText.match(/\d+(\.\d+)?/);

      return match
        ? parseFloat(match[0])
        : null;
    }


    function formatPrice(value) {
      return CURRENCY_SYMBOL + value.toFixed(2);
    }


    /*
     * EX VAT is now the default.
     */
    function getMode() {
      try {
        return localStorage.getItem(STORAGE_KEY) || 'ex';
      } catch (e) {
        return 'ex';
      }
    }


    function setMode(mode) {
      try {
        localStorage.setItem(STORAGE_KEY, mode);
      } catch (e) {}
    }


    function updatePrices() {
      const mode = getMode();
      const prices = document.querySelectorAll(PRICE_SELECTOR);

      prices.forEach(function (el) {
        /*
         * Shopify price is treated as the original
         * VAT-inclusive value.
         */
        if (!el.dataset.priceInc) {
          const original = parsePrice(el.textContent);

          if (original === null) return;

          el.dataset.priceInc = original.toString();
        }

        const incValue = parseFloat(el.dataset.priceInc);

        if (isNaN(incValue)) return;

        /*
         * EX VAT = original Shopify price / 1.20
         * INC VAT = original Shopify price
         */
        const value =
          mode === 'ex'
            ? incValue / (1 + VAT_RATE)
            : incValue;

        const suffix =
          mode === 'ex'
            ? ' ex VAT'
            : ' inc VAT';

        el.textContent =
          formatPrice(value) + suffix;
      });
    }


    function wireToggle() {
      const toggle =
        document.querySelector('.epms-vat-toggle');

      if (!toggle) return;

      const switchEl =
        toggle.querySelector('.epms-vat-toggle__switch');

      const incLabel =
        toggle.querySelector('[data-inc]');

      const exLabel =
        toggle.querySelector('[data-ex]');


      /*
       * EX VAT:
       * - left
       * - aria-pressed=false
       *
       * INC VAT:
       * - right
       * - aria-pressed=true
       */
      function reflectState() {
        const mode = getMode();

        const isInc =
          mode === 'inc';

        switchEl.setAttribute(
          'aria-pressed',
          isInc ? 'true' : 'false'
        );

        exLabel.classList.toggle(
          'is-active',
          !isInc
        );

        incLabel.classList.toggle(
          'is-active',
          isInc
        );
      }


      switchEl.addEventListener('click', function () {
        const next =
          getMode() === 'ex'
            ? 'inc'
            : 'ex';

        setMode(next);

        reflectState();
        updatePrices();
      });


      reflectState();
    }


    function boot() {
      wireToggle();
      updatePrices();

      const observer =
        new MutationObserver(function (mutations) {
          let needsUpdate = false;

          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (n) {
              if (n.nodeType !== 1) return;

              if (
                n.matches &&
                n.matches(PRICE_SELECTOR)
              ) {
                needsUpdate = true;

              } else if (
                n.querySelector &&
                n.querySelector(PRICE_SELECTOR)
              ) {
                needsUpdate = true;
              }
            });
          });

          if (needsUpdate) {
            updatePrices();
          }
        });

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }


    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        boot
      );
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
